import React, { createContext, useContext, useId, useMemo, useRef } from "react";
import { useDrop, useDrag } from "react-dnd";
const DragAndDropContext = createContext([]);
const DropContext = createContext([]);
export default function DragAndDropProvider({ id, onMove, children }) {
    const _id = useId();
    const value = useMemo(() => ([id || _id, onMove]), [_id, id, onMove]);
    return React.createElement(DragAndDropContext.Provider, { value: value }, children);
}
export function DragAndDropItem({ item, children }) {
    const [id, onMove] = useContext(DragAndDropContext);
    //if (!id || !onMove || (item !== 0 && !item))
    //    return <>{children}</>;
    return React.createElement(DragAndDropItemInner, { item: item }, children);
}
export function DragAndDropItemInner({ item, children }) {
    const [id, onMove] = useContext(DragAndDropContext);
    const ref = useRef(null);
    const previewRef = useRef(null);
    const sym = useMemo(() => Symbol(), []);
    const [, drop] = useDrop(() => ({
        accept: id || sym,
        hover(item2, monitor) {
            var _a;
            if (!ref.current) {
                return;
            }
            const dragIndex = item2.item;
            const hoverIndex = item;
            if (dragIndex === hoverIndex) {
                return;
            }
            const hoverBoundingRect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            onMove(dragIndex, hoverIndex);
            item2.item = hoverIndex;
        },
    }), [item, onMove]);
    const [{ isDragging }, drag, preview] = useDrag(() => ({
        type: id || sym,
        item: () => {
            return { item };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }), [id, item]);
    const enabled = (item === 0 || item || null);
    if (enabled) {
        drag(ref);
        drop(preview(previewRef));
    }
    const child = React.Children.only(children);
    return React.createElement(DropContext.Provider, { value: enabled && [ref, isDragging] }, React.cloneElement(child, { ref: previewRef, style: Object.assign(Object.assign({}, (child.props.style || {})), { opacity: !isDragging ? 1 : .5 }) }));
}
export function useDragContext() {
    return useContext(DropContext) || [];
}
